import { ListNode } from "components/objectTree/types";

import { GROUPED_NAME_PATTERN, LEVEL_INDENT_BASE, LEVEL_INDENT_INCREMENT } from "../constants";

export function formatNodeDisplayName<T>(item: ListNode<T>): string {
    const baseName = item.nodeGroup ? removeGroupedCountSuffix(item.node.name) : item.node.name;

    const childPath = item.nodes?.map((n) => `/${n.name}`).join("") ?? "";

    return baseName + childPath;
}

function removeGroupedCountSuffix(name: string): string {
    const match = name.match(GROUPED_NAME_PATTERN);
    return match ? match[1] : name;
}

export function getGroupCountLabel<T>(item: ListNode<T>): string {
    const count = item.nodeGroup?.length ?? 0;
    const hasMore = item.isLast && item.parent?.hasMoreChildren;
    return `${count}${hasMore ? "+" : ""}`;
}

export function calculateTreeIndentation(level: number): number {
    if (level === 0) {
        return 0;
    }
    return LEVEL_INDENT_BASE + (level - 1) * LEVEL_INDENT_INCREMENT;
}
